import React from "react"
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, Navigate } from "react-router-dom";
import Header from "../UserLayout/Header";
import Footer from "../UserLayout/Footer";
import comingSoon from "../../UserAssets/images/comingSoon.png"
import { Breadcrumb } from "antd";


const NotFound = () => {
    return (
        <div>
           
            <div className="invalid-QR">

                <div class="container">                   
                    <div className="invalid">
                        <h1>404</h1>
                        <h5>Not found</h5>
                        <p>The Resource Requested could not be found on this server!</p>
                    </div>
                </div>
            </div>          
        </div>
    )
}
export default connect()(NotFound);
